import {
  GET_ATTSCHEDULE,
  GET_ATTSCHEDULE_SUCCESS,
  GET_ATTSCHEDULE_FAIL,
  DELETE_ATTSCHEDULE,
  DELETE_ATTSCHEDULE_SUCCESS,
  DELETE_ATTSCHEDULE_FAIL,
  UPDATE_ATTSCHEDULE,
  UPDATE_ATTSCHEDULE_SUCCESS,
  UPDATE_ATTSCHEDULE_FAIL,
  ADD_NEW_ATTSCHEDULE,
  ADD_ATTSCHEDULE_SUCCESS,
  ADD_ATTSCHEDULE_FAIL,
  ATTSCHEDULE_LOADING,
  ATTSCHEDULE_RESET,
} from "./actionType";

export const resetAttScheduleState = (actionType) => ({
  type: ATTSCHEDULE_RESET,
  payload: { actionType },
});

export const getAttScheduleSuccess = (actionType, data) => ({
  type: GET_ATTSCHEDULE_SUCCESS,
  payload: { actionType, data },
});

export const getAttScheduleFail = (actionType, error) => ({
  type: GET_ATTSCHEDULE_FAIL,
  payload: { actionType, error },
});

export const getAttSchedule = data => ({
  type: GET_ATTSCHEDULE,
  payload: data,
});

export const getAttScheduleLoading = () => ({
  type: ATTSCHEDULE_LOADING
});

export const deleteAttSchedule = data => ({
  type: DELETE_ATTSCHEDULE,
  payload: data,
});

export const deleteAttScheduleSuccess = data => ({
  type: DELETE_ATTSCHEDULE_SUCCESS,
  payload: data,
});

export const deleteAttScheduleFail = error => ({
  type: DELETE_ATTSCHEDULE_FAIL,
  payload: error,
});

export const updateAttSchedule = data => ({
  type: UPDATE_ATTSCHEDULE,
  payload: data,
});

export const updateAttScheduleFail = error => ({
  type: UPDATE_ATTSCHEDULE_FAIL,
  payload: error,
});

export const updateAttScheduleSuccess = data => ({
  type: UPDATE_ATTSCHEDULE_SUCCESS,
  payload: data,
});

export const addNewAttSchedule = data => ({
  type: ADD_NEW_ATTSCHEDULE,
  payload: data,
});

export const addAttScheduleSuccess = data => ({
  type: ADD_ATTSCHEDULE_SUCCESS,
  payload: data,
});

export const addAttScheduleFail = error => ({
  type: ADD_ATTSCHEDULE_FAIL,
  payload: error,
});